import {isNil, round} from 'lodash'

type amount = number | string;

export function formatAmount(amount: amount) {
  if (!isNil(amount)) {
    return amount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }
  return amount;
}

export function formatAmountWithFraction(value: amount, fractionDigits: number = 1) {
  const amount = Math.abs(Number(value));
  const result = amount.toLocaleString(undefined, { maximumFractionDigits: fractionDigits, minimumFractionDigits: fractionDigits });
  return formatAmount(result);
}

export function extractRoundedDecimalPart(number: number, precision: number) {
  return (10 * (round(number, precision))) % 10;
}

export function extractRoundedIntegerPart(number: number, precision: number) {
  return Math.trunc(round(number, precision));
}
export function unformatAmount(amount: string) {
  return amount.replace(/,/g, '');
}

